import React from "react";

import { AccordionHeader, AccordionItem, AccordionPanel, Body1, Button } from "@fluentui/react-components";
import { ArrowClockwise20Filled, DatabaseLink20Filled } from "@fluentui/react-icons";

import { AccordionValue } from "../../config";
import useAvailableQuoteFeedsStyles from "./availableQuoteFeeds.styles";
import { useSelector } from "react-redux";
import { selectQuoteFeeds, selectToken } from "../../store";
import updateAvailableQuoteFeedersTable from "./utils/updateAvailableQuoteFeedersTable";
import { selectIsConnected } from "../../../../taskpane/components/statusBar/store";
import { useAppDispatch } from "../../../../store";
import { fetchData } from "../../store/asyncThunks";
import { quoteFeeds } from "./utils/quoteFeeds";
import PostHogService from "../../../../service/PostHogService";

const AvailableQuoteFeeds = () => {
  const quoteFeeders = useSelector(selectQuoteFeeds);
  const isConnectionEstablished = useSelector(selectIsConnected);
  const token = useSelector(selectToken);

  const dispatch = useAppDispatch();

  const styles = useAvailableQuoteFeedsStyles();

  const handleUpdateQuoteFeeders = async () => {
    if (!token) return;

    await dispatch(fetchData(token));
    await updateAvailableQuoteFeedersTable({ quoteFeeds: quoteFeeders });

    PostHogService.capture('quote_feeds_updated', {
      total_quote_feeds: quoteFeeders.length,
      component: 'available_quote_feeds',
    });
  };

  return (
    <AccordionItem
      disabled={!isConnectionEstablished}
      value={isConnectionEstablished ? AccordionValue.QuoteFeeds : null}
    >
      <AccordionHeader icon={<DatabaseLink20Filled />}>
        <Body1>Quote Feeds</Body1>
      </AccordionHeader>
      <AccordionPanel>
        <div className={styles.root}>
          <Button
            size="small"
            className={styles.updateButton}
            onClick={handleUpdateQuoteFeeders}
            icon={<ArrowClockwise20Filled />}
          >
            Update Quote Indexes
          </Button>

          <ul>{quoteFeeds(quoteFeeders)}</ul>
        </div>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default AvailableQuoteFeeds;
